export default __webpack_public_path__ + "static/media/unity.4e0ed2cd.png";